import Vue from 'vue'
import Vuex from 'vuex'
import { MembershipStateI } from './modules/MembershipState'
import { downloadState } from './modules/DownloadState'

Vue.use(Vuex)

export interface State {
  MembershipState: MembershipStateI;
  DownloadState: typeof downloadState;
}
export default new Vuex.Store<State>({})
